import AOS from 'aos'; // eslint-disable-line

function init() {
  AOS.init();
}

export default {
  init,
}



// WEBPACK FOOTER //
// ./scripts/comps/aos.js